import {
  FETCH_DUE_PAYMENTS_BEGIN, FETCH_DUE_PAYMENTS_FAILURE,
  FETCH_DUE_PAYMENTS_SUCCESS,
  RESET_REDUX,
  RESET_ON_IMPERSONATION
} from "../../actions/actionTypes";

const initialState = {
  duePayments: [],
  allDuePayments: [],
  loading: false,
  errors: null,
  request: null,
  initialDataCollected: false
}

const duePaymentsReducer = (state = initialState, action:any) => {
  switch (action.type) {
    case FETCH_DUE_PAYMENTS_BEGIN: {
      return {
        ...state,
        loading: true,
        errors: null,
        request: action.payload
      }
    }

    case FETCH_DUE_PAYMENTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        duePayments: action.payload.duePaymentsResponse || [],
        allDuePayments: action.payload.duePaymentsResponse || [],
        initialDataCollected: true,
      }
    }

    case FETCH_DUE_PAYMENTS_FAILURE: {
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
        duePayments: [],
        initialDataCollected: true,
      }
    }

    case RESET_REDUX: {
      return {...initialState}
    }

    case RESET_ON_IMPERSONATION: {
      return {...initialState}
    }

    default:
      return state;
  }
}

export default duePaymentsReducer;
